import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { IHocSinhAceChiTietActionTypes } from "../../action-types/hoc-sinh/IHocSinhAceChiTietActionTypes";
import { IHocSinhAceChiTietReducer } from "../../page-state-model/hoc-sinh/IHocSinhAceChiTietReducer";
const iniState: IHocSinhAceChiTietReducer = {
    status: ePageBaseStatus.is_not_initialization,
    hocSinhAceChiTiets: [],
    hocSinhAceChiTietVms:[]
}
export const hocSinhAceChiTietReducer = (state: IHocSinhAceChiTietReducer = iniState, action: IHocSinhAceChiTietActionTypes): IHocSinhAceChiTietReducer => {
    switch (action.type) {
        case "HOC_SINH_ACE_CHI_TIET_LOAD_START":
            return {
                ...state,
                status: ePageBaseStatus.is_loading
            }
        case "HOC_SINH_ACE_CHI_TIET_LOAD_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                hocSinhAceChiTietVms: action.payload
            }
        case "HOC_SINH_ACE_CHI_TIET_LOAD_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                hocSinhAceChiTietVms: []
            }
        case "HOC_SINH_ACE_CHI_TIET_SHOW_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: true,
                editingData: action.payload
            }
        case "HOC_SINH_ACE_CHI_TIET_CLOSE_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: false,
            }
        case "HOC_SINH_ACE_CHI_TIET_SAVE_START":
            return {
                ...state,
                status: ePageBaseStatus.is_saving
            }
        case "HOC_SINH_ACE_CHI_TIET_SAVE_SUCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload,
                isShowEditModal: false
            }
        case "HOC_SINH_ACE_CHI_TIET_SAVE_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
            }
        case "HOC_SINH_ACE_CHI_TIET_DELETE_START":
            return {
                ...state,
                status: ePageBaseStatus.is_deleting
            }
        case "HOC_SINH_ACE_CHI_TIET_DELETE_SUCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload,
            }
        case "HOC_SINH_ACE_CHI_TIET_DELETE_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
            }
        default:
            return state;
    }
}